module.exports = __webpack_public_path__ + "static/media/emma-frost-icon.24401360.png";